export const getCapabilityFromKey = key => key.get('capability');